// extracted by mini-css-extract-plugin
export default {"preloader":"MeterStaticPreloader_preloader__YWfL8"};